import { getUploadToken, uploadCustomizeInfo } from '@/services/rpc/customize';
import { base64ToFile } from '@/pages/customize/utils';
import { v4 as uuid } from 'uuid';
import OSS from 'ali-oss';

const util: any = {};

const initClient = async () => {
  const result: any = await getUploadToken();
  const client = new OSS({
    region: result.region,
    accessKeyId: result.accessKeyId,
    accessKeySecret: result.accessKeySecret,
    stsToken: result.securityToken,
    bucket: result.bucketName
  });
  return client;
};

const getPosition = async (url) => {
  let response = await fetch(`https://api.7sgood.com/diy/outline?image=${url}`);
  let result = await response.json();
  return result.data;
};

util.getImage = async (dataUrl) => {
  const client = await initClient();
  const file = await base64ToFile(dataUrl);
  const mainImage = await client.put(`${uuid()}.png`, file);
  let url = `https://order-refund.hhocool.com/${mainImage.name}`;
  let arr = await getPosition(url);
  return arr;
};

util.toBlob = (base64) => {
  var bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  // Blobを作成
  try {
    var blob = new Blob([buffer.buffer], {
      type: 'image/png'
    });
  } catch (e) {
    return false;
  }
  return URL.createObjectURL(blob);
};

util.getTopPoint = (arr) => {
  let minPoint = { x: 9999, y: 9999 }; // 给最高点一个默认初始值, 用户获取图片位置的顶点作坐标
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].y < minPoint.y) {
      minPoint = arr[i];
    }
  }
  return minPoint;
};

util.getLinePoint = (arr) => {
  let points = [];
  // 相隔2个点做一个绘画, 让path 更加圆滑一点
  for (let i = 0; i < arr.length; i += 2) {
    if (i + 2 > arr.length) {
      points.push(arr[0].x);
      points.push(arr[0].y);
      break;
    }
    let item = arr[i];
    points.push(item.x);
    points.push(item.y);
  }
  return points;
};

export default util;
